const translations = {
  fr: {
    salesDashboard: {
      salesmanDashboard: 'Tableau de bord vendeur',
      toLink: 'À apparier',
      allCampaigns: 'Toutes les campagnes',
      link: 'Apparier',
      start: 'Début',
      campaignName: 'Nom de la campagne',
      inDays: 'Dans {{days}} jours',
      date: '{{date, D MMM}}',
      noCampaignToLink: 'Aucun appariement à effectuer pour le moment.',
      lastSyncTime: 'Dernière synchronisation faite le {{time, Do MMMM YYYY - hh:mm:ss}}',
      allSalesMembers: 'Tous les vendeurs',
      recentlyLinked: 'Récemment appariées',
      linking: 'Appariemment',
      noRecentlyLinkedCampaign: 'Aucune campagne appariée récemment',
      reachPerformance: 'Performance de la station',
      performanceTooltip: 'Performance de la dernière semaine par rapport à la semaine précédente.',
      timeRangeChoices: {
        LAST_30_DAYS: 'Les 30 derniers jours',
        THIS_MONTH: 'Ce mois-ci',
        LAST_MONTH: 'Le mois dernier',
        THIS_QUARTER: 'Ce trimestre',
        LAST_QUARTER: 'Le trimestre dernier',
      },
      createdPropositions: 'Créées',
      sentPropositions: 'Envoyées',
      acceptedPropositions: 'Acceptées',
      couldNotFetchSummary: 'Impossible d\'obtenir le résumé des propositions',
    },
  },
  en: {
    salesDashboard: {
      salesmanDashboard: 'Sales Dashboard',
      toLink: 'To Pair',
      allCampaigns: 'All campaigns',
      link: 'Pair',
      start: 'Start',
      campaignName: 'Campaign Name',
      inDays: 'In {{days}} days',
      date: '{{date, MMM D}}',
      noCampaignToLink: 'No campaign to pair right now',
      lastSyncTime: 'Last synchronization made on {{time, MMMM Do YYYY - hh:mm:ss}}',
      allSalesMembers: 'All salesmen',
      recentlyLinked: 'Recently Paired',
      linking: 'Pairing',
      noRecentlyLinkedCampaign: 'No recently paired campaign.',
      reachPerformance: 'Station Performance',
      performanceTooltip: 'Station performance of the last week compared to the week before.',
      timeRangeChoices: {
        LAST_30_DAYS: 'Last 30 Days',
        THIS_MONTH: 'This Month',
        LAST_MONTH: 'Last Month',
        THIS_QUARTER: 'This Quarter',
        LAST_QUARTER: 'Last Quarter',
      },
      createdPropositions: 'Created',
      sentPropositions: 'Sent',
      acceptedPropositions: 'Accepted',
      couldNotFetchSummary: 'Impossible to obtain proposals summary',
    },
  },
};

export default translations;



// WEBPACK FOOTER //
// ./src/statsradio/modules/salesDashboard/i18n/salesDashboard.js